import { ReactElement } from 'react';
import { GravitationalDetail, GRAVITY } from '../breakdownMath';
import { formatNumber } from '../breakdownFormat';
import FormulaRow from './FormulaRow';

interface Props {
  detail: GravitationalDetail;
  duration: number;
  combinedMass: number;
}

export default function GravitationalSection({
  detail,
  duration,
  combinedMass,
}: Props): ReactElement {
  const { deltaH, work, power } = detail;

  return (
    <div className="cr-py-2">
      <p className="cr-text-sm cr-text-gray-500 cr-mb-4">
        Work done against gravity over the elevation change of the traverse.
      </p>

      <FormulaRow
        className="cr-mb-4"
        inputs={[
          { header: '−1 ×', value: '−1' },
          { header: 'Mass', value: `${formatNumber(combinedMass, 1)} kg` },
          { header: '× Gravity', value: `${formatNumber(GRAVITY, 2)} m/s²` },
          { header: '× Δ Elevation', value: `${formatNumber(deltaH, 3)} m` },
        ]}
        result={{ header: 'Work', value: `${formatNumber(work, 0)} J` }}
      />
      <FormulaRow
        inputs={[
          { header: 'Work', value: `${formatNumber(work, 0)} J` },
          { header: '÷ Time', value: `${formatNumber(duration, 2)} s` },
        ]}
        result={{ header: 'Gravitational power', value: `${formatNumber(power, 1)} W` }}
      />

      <p className="cr-text-xs cr-text-gray-500 cr-mt-3 cr-italic">
        Δ Elevation read from per-traverse channel <code>ElevDiff_sG3</code> (positive = climbing).
        The −1 in the formula matches the energy-balance sign convention so climbing reduces the
        rider&apos;s effective work, descending adds to it.
      </p>
    </div>
  );
}
